module.exports = __webpack_public_path__ + "img/levelup_icon_cross.30ab5a1c.svg";